import React, { useState } from "react";
import axios from "axios";
import baseUrl from "../../../api/universalApi";
import { toast } from "react-hot-toast";

const UpdateCampaign = ({ campaignDetails,fetchAllCampaigns }) => {
 // console.log("Campaign Details:", campaignDetails);
  const [formData, setFormData] = useState({ ...campaignDetails });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   // console.log("Submitting form data:", formData);
    try {
      const res = await axios.post(
        `${baseUrl}/api/campaign/updateCampaign`,
        formData
      );
      if (res.status === 200) {
        toast.success("Campaign updated successfully");
        fetchAllCampaigns();
      } else toast.error("Failed to update campaign");
    } catch (err) {
      console.error(err);
      toast.error("Error updating campaign");
    }
  };

  return (
    <div className="w-full">
      <h1 className="text-lg font-bold mb-4">Campaign Management</h1>
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-2 items-start"
      >
        <div>
          <label className="block text-sm font-medium">Brand Name</label>
          <input
            type="text"
            name="brandName"
            value={formData.brandName}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Campaign Title</label>
          <input
            type="text"
            name="campaignTitle"
            value={formData.campaignTitle}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Content Link</label>
          <input
            type="text"
            name="contentLink"
            value={formData.contentLink}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Platform</label>
          <input
            type="text"
            name="platform"
            value={formData.platform}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">POC Email</label>
          <input
            type="email"
            name="pocEmail"
            value={formData.pocEmail}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Description</label>
          <textarea
            type="text"
            name="comments"
            value={formData.comments}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <h3 className="col-span-2 font-semibold mt-4 mb-2">VRF Details</h3>

        {/* VRF File Details */}
        <div className="col-span-2 grid grid-cols-2 gap-2">
          <div>
            <label className="block text-sm font-medium">Aadhar Card</label>
            <input
              type="text"
              name="vrfFile.aadhar_card"
              value={formData.vrfFile?.aadhar_card || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, aadhar_card: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Creator Name</label>
            <input
              type="text"
              name="vrfFile.creator_name"
              value={formData.vrfFile?.creator_name || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, creator_name: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">
              Emergency POC Name
            </label>
            <input
              type="text"
              name="vrfFile.emergency_poc_name"
              value={formData.vrfFile?.emergency_poc_name || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: {
                    ...prev.vrfFile,
                    emergency_poc_name: e.target.value,
                  },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">
              Emergency POC Contact
            </label>
            <input
              type="text"
              name="vrfFile.emergency_poc_contact"
              value={formData.vrfFile?.emergency_poc_contact || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: {
                    ...prev.vrfFile,
                    emergency_poc_contact: e.target.value,
                  },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">GST (Optional)</label>
            <input
              type="text"
              name="vrfFile.gst"
              value={formData.vrfFile?.gst || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, gst: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Pancard</label>
            <input
              type="text"
              name="vrfFile.pancard"
              value={formData.vrfFile?.pancard || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, pancard: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">
              Bank Account Number
            </label>
            <input
              type="text"
              name="vrfFile.bank_account_number"
              value={formData.vrfFile?.bank_account_number || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: {
                    ...prev.vrfFile,
                    bank_account_number: e.target.value,
                  },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Bank IFSC</label>
            <input
              type="text"
              name="vrfFile.bank_ifsc"
              value={formData.vrfFile?.bank_ifsc || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, bank_ifsc: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Bank Name</label>
            <input
              type="text"
              name="vrfFile.bank_name"
              value={formData.vrfFile?.bank_name || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  vrfFile: { ...prev.vrfFile, bank_name: e.target.value },
                }))
              }
              className="w-full border px-3 py-2 rounded"
            />
          </div>
        </div>

        <div className="col-span-2 flex justify-end">
          <button
            type="submit"
            className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateCampaign;
